module.exports = __webpack_public_path__ + "static/media/bg-pic-about.4cbf0397.jpg";